const PAYMENT_CYCLES = [
    'Monthly',
    'Semi-Monthly',
    'Bi-Weekly',
    'Weekly'
]

const COLLECTION_METHODS = ['Scheduled Installment Earnings', 'True Daily Earnings']

const PAYMENT_STATUSES = ['Unpaid', 'Partially Paid', 'Fully Paid']

const PAYMENT_TYPES = ['Payment', 'Refund', 'Void', 'Return', 'Fee', 'Payoff', 'Write-Off', 'Forgiven']

const PAYMENT_METHODS = ['Cash', 'Check', 'ACH Checking', 'ACH Savings', 'Bank Draft', 'Credit Card', 'Debit Card', 'Money Order', 'Cashiers Check', 'Travelers Check', 'Pre-Paid Debit Card', 'Third-Party', 'Unknown']

const IRS_CASH_TYPES = ['Cash', 'Non-Cash']

const PAYMENT_SOURCES = ['Walk-In', 'Mail', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Venmo', 'Zelle', 'PayPal', 'Cash App', 'System', 'Editor', 'Other']

const PAYMENT_SOURCES_BY_METHOD = {
    'cash': ['Walk-In', 'Other'],
    'check': ['Walk-In', 'Mail', 'Other'],
    'ach checking': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'ach savings': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'bank draft': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'checking': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'credit card': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'debit card': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'money order': ['Walk-In', 'Mail', 'Other'],
    'cashiers check': ['Walk-In', 'Mail', 'Other'],
    'travelers check': ['Walk-In', 'Mail', 'Other'],
    'pre-paid debit card': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other'],
    'third-party': ['Walk-In', 'Venmo', 'Zelle', 'PayPal', 'Cash App', 'Other'],
    'unknown': ['Walk-In', 'Phone Call', 'Web', 'SMS', 'Mobile App', 'IVR', 'Other']
}

const PAYMENT_CATEGORIES = ['Deposit', 'Initial Down', 'Deferred Down', 'MV Loan', 'CPI', 'After-Sale Charges', 'Service', 'Drive-Out Price', 'Late Fee', 'NSF', 'Bounce', 'Reversal', 'Adjustment', 'Unknown']

const FEE_CATEGORIES = ['Late Fee', 'NSF', 'Bounce', 'Reversal']

const LATE_FEE_METHODS = ['scheduled', 'past']

const PAYMENT_PROGRESS = ['Pending', 'Processing', 'Processed', 'Declined', 'Failed', 'Returned', 'Refunded', 'Voided', 'Discarded']

const ACCOUNT_TYPES = ['Checking', 'Savings', 'Credit Card', 'Debit Card', 'Pre-Paid Debit Card']

const BANK_DRAFT_RETURN_CODES = [
    { code: 'R01', reason: 'Insufficient Funds' },
    { code: 'R02', reason: 'Account Closed' },
    { code: 'R03', reason: 'No Account / Unable to Locate Account' },
    { code: 'R04', reason: 'Invalid Account Number Structure' },
    { code: 'R05', reason: 'Unauthorized Consumer Debit using Corporate SEC Code' },
    { code: 'R06', reason: 'ODFI Requested Return' },
    { code: 'R07', reason: 'Customer Revoked Authorization' },
    { code: 'R08', reason: 'Payment Stopped' },
    { code: 'R09', reason: 'Uncollected Funds' },
    { code: 'R10', reason: `Originator not known and/or not authorized to Debit Receiver's Account` }
]

export {
    PAYMENT_CYCLES,
    COLLECTION_METHODS,
    PAYMENT_STATUSES,
    PAYMENT_TYPES,
    PAYMENT_METHODS,
    IRS_CASH_TYPES,
    PAYMENT_SOURCES,
    PAYMENT_SOURCES_BY_METHOD,
    PAYMENT_CATEGORIES,
    FEE_CATEGORIES,
    LATE_FEE_METHODS,
    PAYMENT_PROGRESS,
    ACCOUNT_TYPES,
    BANK_DRAFT_RETURN_CODES
}
